export default __webpack_public_path__ + "static/media/4.62203b31.png";